import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { HairRestorationHero } from '../components/hair-restoration/HairRestorationHero';
export function HairRestorationPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2536">
      <Navigation data-id="element-2537" />
      <main data-id="element-2538">
        <HairRestorationHero data-id="element-2539" />
      </main>
      <Footer data-id="element-2540" />
    </div>;
}